export default function (url) {
    if (typeof window.history.pushState === "undefined") {
        return;
    }

    window.history.pushState({}, window.document.title, url);
}
